import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, Protected } from "@/context/AuthContext";
import { LivePayments } from "@/components/LivePayments";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import PayPage from "@/pages/PayPage";
import UserOverview from "@/pages/user/UserOverview";
import StaticQR from "@/pages/user/StaticQR";
import UserPayouts from "@/pages/user/UserPayouts";
import UserTransactions from "@/pages/user/UserTransactions";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminUserDetail from "@/pages/admin/AdminUserDetail";
import AdminPayouts from "@/pages/admin/AdminPayouts";
import AdminTransactions from "@/pages/admin/AdminTransactions";

const U = (el) => <Protected role="user">{el}</Protected>;
const A = (el) => <Protected role="admin">{el}</Protected>;

function App() {
  return (
    <AuthProvider>
      <LivePayments />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/pay/:username" element={<PayPage />} />
          <Route path="/dashboard" element={U(<UserOverview />)} />
          <Route path="/dashboard/qr" element={U(<StaticQR />)} />
          <Route path="/dashboard/payouts" element={U(<UserPayouts />)} />
          <Route path="/dashboard/transactions" element={U(<UserTransactions />)} />
          <Route path="/admin" element={A(<AdminOverview />)} />
          <Route path="/admin/users" element={A(<AdminUsers />)} />
          <Route path="/admin/users/:id" element={A(<AdminUserDetail />)} />
          <Route path="/admin/payouts" element={A(<AdminPayouts />)} />
          <Route path="/admin/transactions" element={A(<AdminTransactions />)} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
